import { observer } from "mobx-react";
import { IApplicationFilterComponent } from "../BaseFilterComponents/IApplicationFilterComponent";
import { CallDirection } from "stores/ApplicationFilters/Filters/CallDirection";
import { Stack } from "@mui/material";
import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useOptionRestriction } from "../BaseFilterComponents/useRestrictedOptions";
import { usePruneSelectedValues } from "../BaseFilterComponents/usePruneSelectedValues";

export const CallDirectionsFilter = observer(function (
    props: IApplicationFilterComponent,
) {
    const { isValueAllowed: isAllowed } = useOptionRestriction({
        optionRestriction: props.optionRestriction,
        restrictedValues: props.restrictedValues,
    });

    usePruneSelectedValues({
        selectedValues: props.store.callDirections,
        setSelectedValues: (values) => props.store.setCallDirections(values),
        isValueAllowed: isAllowed,
    });

    const options = [
        {
            id: "application-filters-call-direction-inbound",
            label: "Inbound",
            value: CallDirection.Inbound,
        },
        {
            id: "application-filters-call-direction-outbound",
            label: "Outbound",
            value: CallDirection.Outbound,
        },
        {
            id: "application-filters-call-direction-transfer",
            label: "Transfer",
            value: CallDirection.Transfer,
        },
        {
            id: "application-filters-call-direction-other",
            label: "Other",
            value: CallDirection.Other,
        },
    ];

    return (
        <Stack>
            {options.map((option) => {
                const allowed = isAllowed(option.value);
                return (
                    <FormControlLabel
                        key={option.id}
                        label={option.label}
                        control={
                            <Checkbox
                                id={option.id}
                                onChange={() => {
                                    if (!allowed) return;
                                    props.store.toggleCallDirection(option.value);
                                }}
                                checked={props.store.callDirections?.includes(
                                    option.value,
                                )}
                                disabled={!allowed}
                            />
                        }
                        sx={{ maxHeight: "28px" }}
                    />
                );
            })}
        </Stack>
    );
});
